import React from 'react'
import "./SubStyle.css"

const Care_Sale = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">Care Homes for Sale</h1>
      <p className="SubServices-pera">Explore a wide range of care homes available for purchase across the UK. Whether you are an experienced operator looking to expand your portfolio or a first-time buyer entering the care sector, we provide expert guidance throughout the acquisition process. Our team helps identify suitable opportunities, conduct due diligence, and support successful transactions.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Care_Sale
